import { FC, useMemo, useState } from 'react';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import ModeOfTravelIcon from '@mui/icons-material/ModeOfTravel';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import MainLayout from 'src/components/NavigationPanel/MainLayout';
import PlaygroundSpeedDial from './SpeedDial';
import useIsMobile from 'src/hooks/useIsMobile';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import { IPanelLinks } from 'src/models/IPanelLinks';

const roleLinks: IPanelLinks[] = [
  {
    name: 'Chat',
    path: '/host-support',
    icon: <LiveHelpIcon className='icon-tab-chat' />,
    role: 'all'
  },
  {
    name: 'Calendar',
    path: '/calendar',
    icon: <CalendarMonthIcon className='icon-tab' />,
    role: 'all'
  },
  {
    name: 'Order',
    path: '/order',
    icon: <AssignmentOutlinedIcon className='icon-tab' />,
    role: 'all'
  },
  {
    name: 'Next Out',
    path: '/order/next-out',
    icon: <DoubleArrowIcon className='icon-tab' />,
    role: 'all'
  },
  {
    name: 'Next Return',
    path: '/order/next-return',
    icon: <ModeOfTravelIcon className='icon-tab' />,
    role: 'all'
  },
  {
    name: 'Client',
    path: '/client',
    icon: <PeopleAltIcon className='icon-tab' />,
    role: 'admin'
  },
  {
    name: 'Host report',
    path: '/report/host',
    icon: <ReceiptLongIcon className='icon-tab' />,
    role: 'all'
  },
  {
    name: 'Admin',
    path: '/admin',
    icon: <SettingsIcon className='icon-tab admin-icon' fontSize='medium' />,
    role: 'admin'
  },
  {
    name: 'Van',
    path: '/van',
    icon: <AirportShuttleIcon className='icon-tab' />,
    role: 'all'
  },
  {
    name: 'Log Out',
    path: '',
    icon: <ExitToAppOutlinedIcon className='icon-tab' />,
    role: 'all'
  }
];

const NavigationPanel: FC = () => {
  const isMobile = useIsMobile();
  const { role } = useTypedSelector(state => state.auth);
  const [links, setLinks] = useState<IPanelLinks[] | null>(null);

  useMemo(() => {
    let newLinks;
    if (isMobile) newLinks = roleLinks;
    else newLinks = roleLinks.filter(el => el.name !== 'Log Out');
    if (role === 'admin') setLinks(newLinks);
    else {
      const hostLinks = newLinks.filter(el => el.role !== 'admin');
      setLinks(hostLinks);
    }
  }, [role]);

  return (
    <>
      {links ? (
        isMobile ? (
          <PlaygroundSpeedDial links={links} />
        ) : (
          <MainLayout links={links} />
        )
      ) : (
        <></>
      )}
    </>
  );
};

export default NavigationPanel;
